import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { TotemWidget } from '../totem-widget';
import { LocalizationService } from 'pg-lib/services/localization.service';

@Component({
    selector: 'app-totem-widget-countdown',
    templateUrl: './totem-widget-countdown.component.html',
    styleUrls: ['./totem-widget-countdown.component.scss'],
    standalone: false
})
export class TotemWidgetCountdownComponent extends TotemWidget implements OnInit, OnDestroy {

    size:'md' = 'md'

    @Input() date:string

    constructor(public elementRef:ElementRef, private localizationService:LocalizationService) {
        super(elementRef);
    }

    displayCountdown:string = null;

    private _refreshInterval = null;

    ngOnInit(): void {
        super.ngOnInit()

        let _date = new Date(this.date)

        this._refreshInterval = setInterval(() => {
            this.displayCountdown = this.localizationService.format.duration(_date.getTime() - Date.now(), true)
        }, 200)
    }

    ngOnDestroy(): void {
        clearInterval(this._refreshInterval)

        super.ngOnDestroy()
    }
}
